<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-12 mb-4">
          <CiSkeletonItem class="skeleton__headline block h-[30px] w-2/5" />
        </div>
      </div>
      <div class="row no-gutters">
        <div
          class="col-12 col-md-6 col-lg-4"
          style="padding-right: 7.5px"
        >
          <CiSkeletonItem class="block h-[295px] w-full" />
        </div>
        <div
          class="col-md-6 col-lg-4 hidden md:block"
          style="padding: 0 7.5px"
        >
          <CiSkeletonItem class="block h-[295px] w-full" />
        </div>
        <div
          class="col-lg-4 hidden lg:block"
          style="padding-left: 7.5px"
        >
          <CiSkeletonItem class="block h-[295px] w-full" />
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>
